class QuantityInput extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input[type="number"]');
    this.decreaseBtn = this.querySelector('[data-qty-decrease]');
    this.increaseBtn = this.querySelector('[data-qty-increase]');
    this.min = Number(this.input?.min || 0);
    this.debounceTimer = null;

    this.decreaseBtn?.addEventListener('click', () => this.step(-1));
    this.increaseBtn?.addEventListener('click', () => this.step(1));
    this.input?.addEventListener('change', () => this.emitChange());
  }

  step(delta) {
    const next = Math.max(this.min, Number(this.input.value || 0) + delta);
    this.input.value = next;
    this.emitChange();
  }

  emitChange() {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.dispatchEvent(
        new CustomEvent('quantity:change', {
          bubbles: true,
          detail: { value: Number(this.input.value) },
        })
      );
    }, 250);
  }
}

if (!customElements.get('quantity-input')) {
  customElements.define('quantity-input', QuantityInput);
}
